enum TerranisBusinessLines {
    'VITI' = 'viti',
    'AGRI' = 'agri',
}
export default TerranisBusinessLines;
